export const getFieldIdWithoutIndex = (fieldId: string) =>
  fieldId.split('_').slice(0, -1).join('_');
